/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Tuda_Engineering_Technology25Inputs */

const en__field_enum_tuda_engineering_technology25 = /** @type {(inputs: _Field_Enum_Tuda_Engineering_Technology25Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Engineering & Technology`)
};

const de__field_enum_tuda_engineering_technology25 = /** @type {(inputs: _Field_Enum_Tuda_Engineering_Technology25Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingenieurwesen & Technologie`)
};

/**
* | output |
* | --- |
* | "Engineering & Technology" |
*
* @param {_Field_Enum_Tuda_Engineering_Technology25Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_tuda_engineering_technology25 = /** @type {((inputs?: _Field_Enum_Tuda_Engineering_Technology25Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Tuda_Engineering_Technology25Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_tuda_engineering_technology25(inputs)
	return de__field_enum_tuda_engineering_technology25(inputs)
});
export { _field_enum_tuda_engineering_technology25 as "_field_enum_TUDA_ENGINEERING_TECHNOLOGY" }